import React, { useEffect, useRef, useState } from "react";
import "../Style/aboutus.css";



import AboutUsOne from "../components/aboutusone";
import AboutUsWay from "../components/aboutusway";
import AboutWork from "../components/aboutwork";
import AboutValue from "../components/aboutvalue";
import AboutUsLeader from "../components/aboutusleader";
import AboutUsBoard from "../components/aboutusboard";
import OurTeam from "../components/Ourteam";
import AddressSection from "../components/AddSection";
import FormsSection from "../components/Forms";
import BlogsSection from "../components/Ourblogs";
import PageFooter from "../components/Footer";

function AboutusPage() {
  const overlayRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (overlayRef.current) observer.observe(overlayRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="aboutus-page">
        {/* CSS-only pattern layers, no images */}
        <div className="aboutus-grid-pattern" aria-hidden="true" />
        <div className="aboutus-blob aboutus-blob-1" aria-hidden="true" />
        <div className="aboutus-blob aboutus-blob-2" aria-hidden="true" />
        <div className="aboutus-blob aboutus-blob-3" aria-hidden="true" />

        <div
          className={`aboutus-overlay ${isVisible ? "aboutus-visible" : ""}`}
          ref={overlayRef}
        >
          <div className="aboutus-glass">
            

            <span className="aboutus-eyebrow aboutus-anim aboutus-anim-2">
              About MPeoples
            </span>

            <h1 className="aboutus-title aboutus-anim aboutus-anim-3">
              Built for People. Powered by Technology.
            </h1>

            <p className="aboutus-description aboutus-anim aboutus-anim-4">
              We develop innovative software products and deliver high-quality services that help businesses grow faster and smarter.
            </p>

            <button className="aboutus-btn aboutus-anim aboutus-anim-5">
              Let&rsquo;s Build Together <span>↗</span>
            </button>
          </div>
        </div>
      </section>

      <AboutUsOne />
      <AboutUsWay />
      <AboutWork />
      <AboutValue />
      <AboutUsLeader />
      <AboutUsBoard />
      <OurTeam />
      <AddressSection />
      <FormsSection />
      <BlogsSection />
      <PageFooter />
    </>
  );
}

export default AboutusPage;